<template>
  <v-layout row justify-center>
    <v-flex xs12 v-if="getActivity.SpecialFormFillUp == true"
      ><v-card style="margin-left: 30px;">
        <v-flex xs12>
          <v-card>
            <v-container fluid grid-list-md>
              <v-card color="white">
                <v-layout row>
                  <v-text-field
                    tabindex="1"
                    class="mt-0 fs-25px"
                    flat
                    hide-details
                    label="REG No."
                    prepend-inner-icon="search"
                    single-line
                    solo
                    v-model="reg_no"
                    ref="reg_no_search"
                  ></v-text-field>
                  <v-card-actions>
                    <v-btn color="info" dark @click="searchStudent"
                      >Search</v-btn
                    >

                    <v-btn color="red" dark @click="goback">Back</v-btn>
                  </v-card-actions>
                </v-layout>
              </v-card>
            </v-container>
          </v-card>
        </v-flex>

        <v-layout row style="padding: 20px;">
          <v-flex
            xs4
            class="pr-1"
            v-if="getAdminFormFillUpSubject.form_fill_up"
          >
            <v-card>
              <v-container fluid grid-list-md>
                <StudentInfo />
                <FormFillUpFee />
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs8>
            <v-card>
              <v-container
                fluid
                grid-list-md
                v-if="getAdminFormFillUpSubject.total_subject"
              >
                <compulsorySubject
                  v-if="getAdminFormFillUpSubject.compulsory_subject.length > 0"
                />
                <electiveSubject
                  v-if="
                    Object.keys(getAdminFormFillUpSubject.elective_subject)
                      .length
                  "
                />
                <optionalSubject
                  v-if="getAdminFormFillUpSubject.optional_subject.length > 0"
                />
                <improvementSubject
                  v-if="
                    getAdminFormFillUpSubject.improvement_subject.length > 0
                  "
                />
                <v-toolbar flat dark>
                  <v-toolbar-title>Update Mobile No.</v-toolbar-title>
                </v-toolbar>
                <v-card>
                  <v-card-text>
                    <v-form>
                      <v-text-field
                        name="mobile"
                        v-model="mobile"
                        label="Mobile No."
                        v-validate="'required'"
                        :error-messages="errors.collect('mobile')"
                        data-vv-name="mobile"
                        required
                        prepend-icon="edit"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                </v-card>
                <div class="justify-center layout px-0 mt-2">
                  <v-btn color="success" @click="save"
                    >Apply For Special Form Fill-up</v-btn
                  >
                </div>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex md12 v-if="getActivity.SpecialFormFillUp == false" style="padding: 10px;">
      <v-alert :value="true" type="error">
        <h2 style="color: #fff;">Special Form Fill-up Not Started Yet</h2>
      </v-alert>
    </v-flex>
        <!-- {{ getAdminFormFillUpSubject.compulsory_subject }} -->
 
    <!-- Validation Warning Dialog -->
    <v-dialog v-model="validDialog" max-width="420px" persistent>
      <v-card>
        <v-card-title
          class="headline"
          style="background-color: #5666BE; color: #fff;"
        >
          Missing Marks
        </v-card-title>
        <v-card-text>
          <p style="color: red;">{{ dialogMessage }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo"
            style="color: #fff;"
            small
            @click="validDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<!-- Special Form Fillup List -->
<!-- <template >
    <specialFormFillupList ></specialFormFillupList>
  </template> -->
<!-- Close Special Form Fillup List -->

<script>
import compulsorySubject from "@/views/collegeUserPanel/specialff/compulsory_subject";
import electiveSubject from "@/views/collegeUserPanel/specialff/elective_subject";
import StudentInfo from "@/views/collegeUserPanel/specialff/student_info";
import FormFillUpFee from "@/views/collegeUserPanel/specialff/FormFillUpFee";
import improvementSubject from "@/views/collegeUserPanel/specialff/improvement_subject";
import optionalSubject from "@/views/collegeUserPanel/specialff/optional_subject";
// import specialFormFillupList from "@/components/probable/specialFormFillup/specialFormFillupList";
export default {
  name: "SPFormFillup",
  components: {
    StudentInfo,
    FormFillUpFee,
    compulsorySubject,
    electiveSubject,
    improvementSubject,
    optionalSubject,
    // specialFormFillupList
  },
  computed: {
    formFillUpInfo() {
      return this.$store.getters.getSpetialFFstuden;
    },
    getLoggedInExam() {
      return this.$store.getters.getLoggedInExam;
    },
    getLoggedInYear() {
      return this.$store.getters.getLoggedInYear;
    },
    getSchema() {
      return this.$store.getters.formFillUpConfirmByAdmin;
    },
    getAdminFormFillUpSubject() {
      return this.$store.getters.getAdminFormFillUpSubject;
    },
    getAdminId() {
      return this.$store.getters.getAuthUserID;
    },
    getActivity() {
      return this.$store.getters.getExamActivityStatus;
    },
  },
  data: () => ({
    validDialog: false,
    dialogMessage: "",
    dialog: false,
    reg_no: "",
    mobile: "",
    form_fill_up_id: null,
    fees: {},
    selected: {
      compulsory_subject: [],
      elective_subject: [],
      improvement_subject: [],
      optional_subject: [],
    },
    confirm_by_student: [],
  }),
  created() {
    // console.log("reg_no", this.reg_no);
    // this.$store.dispatch("getAdminFormFillUpSubject", {
    //   form_fill_up_id: this.formFillUpInfo.form_fill_up.id,
    //   reg_no: this.reg_no
    // });
    this.col_code = JSON.parse(localStorage.getItem("college-user"));
    this.localData = JSON.parse(localStorage.getItem("current-privilege"));
    this.getActivityList();
  },

  methods: {
    searchStudent() {
      let reg_no = this.reg_no;
      let sub_code;
      if (this.localData.degree_code == 1) {
        sub_code = this.localData.degree_group_code;
      } else {
        sub_code = this.localData.subject.subject_code;
      }
      this.$store
        .dispatch("fetchDataEntryDetailsList", {
          reg_no: reg_no,
          exam_code: this.localData.exam_master.exam_code,
          exam_year: this.localData.exam_master.exam_year,
          subject_code: sub_code,
          college_code: this.col_code.college_code,
        })
        .then((response) => {
          this.$store.dispatch("getAdminFormFillUpSubject", {
            form_fill_up_id: this.formFillUpInfo.form_fill_up.id,
            reg_no: this.reg_no,
          });
        });
    },
    getActivityList() {
      let data = {
        exam_code: this.localData.exam_master.exam_code,
        exam_year: this.localData.exam_master.exam_year,
      };
      this.$store.dispatch("getExamActivityStatus", data);
    },
    calculateFeePerStudentAdmin(options) {
      this.$store.dispatch("calculateFeePerStudentAdmin", options);
    },
    confirmSubject: function(selected) {
      this.confirm_by_student = [];
      let all_subjects = [];
      Object.keys(selected).forEach((element) => {
        let subjects = this.selected[element];
        subjects.forEach((element) => {
          all_subjects.push({
            paper_code: element.paper_code,
            incourse_marks: element.incourse_marks,
            att_incourse_marks: element.att_incourse_marks,
            form_fill_up_id: element.form_fill_up_id,
            form_fill_up_details_id: element.id,
          });
        });
      });
      this.confirm_by_student = all_subjects;
      this.calculateFeePerStudentAdmin({
        form_fill_up_id: this.formFillUpInfo.form_fill_up.id,
        paper_code: all_subjects,
      });
    },
    // save() {
    //   let self = this;
    //   self.$root.$confirm("Are You Sure To Submit ?").then((confirm) => {
    //     if (confirm) {
    //       let item = self.getSchema;
    //       let student_info = {
    //         reg_no: this.formFillUpInfo.form_fill_up.reg_no,
    //         mobile: self.mobile,
    //       };

    //       const formData = Object.assign(self.getSchema, {
    //         confirm_subjects: self.confirm_by_student,
    //         form_fill_up_id: this.formFillUpInfo.form_fill_up.id,
    //         fees: this.fees,
    //         student_info: student_info,
    //       });
    //       const isEmpty = !Object.values(item).some(
    //         (x) => x !== null && x !== ""
    //       );
    //       console.log('formdata',formData)
    //       if (!isEmpty) {
    //         console.log("Tanvir! this is sff data", formData);
    //         self.$store
    //           .dispatch("formFillUpConfirmColUser", formData)
    //           .then(function(data) {})
    //           .catch(function(error) {
    //             console.log(error);
    //             // self.$store.dispatch("fetchAllExamsnData");
    //           });
    //       } else {
    //         // console.log("empty");
    //       }
    //     }
    //   });
    // },
    save() {
      let self = this;

      // Collect all selected subjects
      const allSubjects = [
        ...this.selected.compulsory_subject,
        ...this.selected.elective_subject,
        ...this.selected.optional_subject,
        ...this.selected.improvement_subject,
      ];

      // Check for missing marks, but skip subjects where core incourse_marks is 0
      const invalidSubjects = allSubjects.filter((subj) => {
        // skip validation if core_paper.incourse_marks is 0
        if (Number(subj.core_paper.incourse_marks) === 0) return false;

        return (
          subj.incourse_marks === null ||
          subj.incourse_marks === "" ||
          subj.att_incourse_marks === null ||
          subj.att_incourse_marks === ""
        );
      });

      if (invalidSubjects.length > 0) {
        // Show dialog with meaningful message
        self.dialogMessage = `Please input both Incourse and Attendance Incourse marks for all subjects before submitting. Missing in ${invalidSubjects.length} subjects.`;
        self.validDialog = true;
        return; // stop submission
      }

      // Show confirm dialog if all filled
      self.$root.$confirm("Are You Sure To Submit ?").then((confirm) => {
        if (confirm) {
          let item = self.getSchema;
          let student_info = {
            reg_no: this.formFillUpInfo.form_fill_up.reg_no,
            mobile: self.mobile,
          };

          const formData = Object.assign(self.getSchema, {
            confirm_subjects: self.confirm_by_student,
            form_fill_up_id: this.formFillUpInfo.form_fill_up.id,
            fees: this.fees,
            student_info: student_info,
          });

          self.$store
            .dispatch("formFillUpConfirmColUser", formData)
            .then((data) => {})
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    goback() {
      this.$router.go(-1);
    },
  },
  watch: {
    "selected.compulsory_subject": function(val, oldval) {
      this.confirmSubject(this.selected);
    },
    "selected.elective_subject": function(val, oldval) {
      this.confirmSubject(this.selected);
    },
    "selected.improvement_subject": function(val, oldval) {
      this.confirmSubject(this.selected);
    },
    "selected.optional_subject": function(val, oldval) {
      this.confirmSubject(this.selected);
    },
    confirm_by_student: function(val, oldval) {},
  },
};
</script>
